import { Text, Box, VStack } from '@chakra-ui/react';
import { useBinderCardColors } from '../hooks/useBinderCardColors';
import DataTableCard from './DataTableCard';

interface QuoteDetailsCardProps {
  data?: any;
}

const QuoteDetailsCard = ({ data }: QuoteDetailsCardProps) => {
  const colors = useBinderCardColors();
  const vehicles = data?.vehicles || [];
  const messages = data?.messages || [];

  const headers = ['Vehicle', 'Message', 'Deductible Premium'];
  const rows = vehicles.map((vehicle: any) => [
    vehicle.name,
    vehicle.messages.map((msg: string, idx: number) => (
      <Text key={idx} color="gray.400" fontStyle="italic" fontSize="sm">
        {msg}
      </Text>
    )),
    vehicle.deductables.map((deductable: any, idx: number) => (
      <Text key={idx} color="gray.400" fontStyle="italic" fontSize="sm">
        {deductable.premium}
      </Text>
    )),
  ]);

  // Handle case when no vehicles
  if (vehicles.length === 0) {
    return (
      <Box p={4} borderRadius="md" bg={colors.emptyFieldBgColor}>
        <Text color="gray.500" fontStyle="italic" textAlign="center">
          No vehicle quote details available
        </Text>
      </Box>
    );
  }

  return (
    <VStack spacing={6} align="stretch">
      <Box p={3} bg={colors.emptyFieldBgColor} borderRadius="md">
        {messages.map((msg: string, idx: number) => (
          <Text key={idx} color={colors.labelColor}>
            {msg}
          </Text>
        ))}
      </Box>
      <DataTableCard headers={headers} rows={rows} />
    </VStack>
  );
};

export default QuoteDetailsCard;
